module.exports = __webpack_public_path__ + "img/banner.117a651c.png";